<!--
 * @Author: gzm
 * @Date: 2021-06-17 17:27:01
 * @Description:代码管理弹窗
-->
<!--
* www.cloudscope.cn
* Copyright (c) 2019. All Rights Reserved.
* -->
<template>
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :before-close="handleClose" append-to-body
               custom-class="data-dictionary-details-dialog" class="dialog-box" title="代码值">
        <div class="dialog-content">
            <div class="right-box">
                <div class="multi-level-code">
                    <div class="select-wrap">
                        <div class="code-header">
                            <h3 class="title">代码值</h3>
                            <div style="display:inline-block;width:200px">
                                <el-button size="small" type="primary" @click="onSubmitDownLoad">下载模板</el-button>
                                <el-upload class="upload-demo" :show-file-list="false" action="/api/v1/auth/code/import"
                                           :http-request="uploadSectionFile" style="display: inline-block;">
                                    <el-button size="small" type="primary">批量导入</el-button>
                                </el-upload>
                            </div>
                        </div>
                        <div class="input-box">
                            <div class="code-wrap">
                                <el-input class="input-new-tag" v-model="inputMultValue" ref="saveMultTagInput" size="small"
                                          placeholder="请输入前缀" :disabled="codeExdisabled">
                                </el-input>
                                <el-input class="input-new-tag" v-model="inputDesValue" ref="saveDesTagInput" size="small"
                                          style="width:175px" placeholder="请输入代码类型描述">
                                </el-input>
                                <el-button class="button-new-tag" size="small" @click="multiLevelSumbit">确定</el-button>
                            </div>
                        </div>
                    </div>
                    <div class="tree-wrap" v-loading="treeLoading">
                        <code-tree ref="CodeTree" v-if="dialogVisible" @fieldDraggable="changeFieldDraggable"
                                   @getCodeInfo='getCodeInfo' :columnData="columnData" @show="show">
                        </code-tree>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import axios from 'axios';
import CodeTree from './cs-codeTree.vue';
export default {
    data () {
        return {
            treeLoading: false,
            dialogVisible: false,
            columnData: {},
            inputMultValue: '', // 代码类型
            inputDesValue: '', // 代码类型描述
            codeExdisabled: false, // 代码前缀是否可编辑
            codeTypeIdNew: '', // 代码类型Id
            fieldDraggable: true,
            codeType: '',
            codesData: {}
        };
    },
    props: [],
    components: {
        CodeTree
    },

    computed: {},

    mounted () {
    },
    watch: {

    },
    methods: {
        /**
         * @author: gzm
         * @description: 下载模板
         * @param {} {*}
         */
        onSubmitDownLoad () {
            axios({
                url: '/api/v1/auth/code/template',
                params: {},
                method: 'get',
                headers: { 'Content-Type': 'application/json; application/octet-stream' },
                responseType: 'blob'
            }).then((res) => {
                // console.log(res);
            }).catch((error) => {
                console.log(error);
            });
        },
        /**
         * @author: gzm
         * @description: 添加/修改代码类型
         * @param {} {*}
         */
        async multiLevelSumbit () {
            if (!/^[a-zA-Z0-9\-\_]{1,16}$/.test(this.inputMultValue)) {
                this.$message.warning('请输入至多16位的合法字符(字母、数字、-、_)');
                return;
            }
            if (this.codeExdisabled) {
                let param = {
                    codeType: this.inputMultValue,
                    description: this.inputDesValue,
                    id: this.codeTypeIdNew
                };
                let res = await this.$api.CodeManagement.updateCodetype(param);
                if (res.code === 200) {
                    this.$message.success('修改代码前缀成功');
                } else {
                    this.$message.warning(res.msg);
                }
            } else {
                let param = {
                    codeType: this.inputMultValue,
                    description: this.inputDesValue
                };
                let res = await this.$api.CodeManagement.addCodetype(param);
                if (res.code === 200) {
                    this.$message.success('添加代码前缀成功');
                    this.$parent.query();
                    this.codeExdisabled = true;// 添加成功后代码前缀不可修改
                    this.$refs.CodeTree.editDisabled = false;// 添加成功后代码树才可操作
                    this.codeTypeIdNew = res.data.id;
                    this.columnData = res.data;
                    if (res.data.createWay === 1) {
                        // 添加代码类型后返回数据createWay为1，
                        // 则代码树中添加节点弹窗中代码不能编辑，若为2，则可以编辑。
                        // 但是在编辑节点中的所有弹窗都不能编辑代码字段。含义和业余代码可以编辑。
                        this.$refs.CodeTree.codeValuedisabled = true;
                    } else {
                        this.$refs.CodeTree.codeValuedisabled = false;
                    }
                } else {
                    this.$message.warning(res.msg);
                }
            }
        },
        /**
         * @author: wangwl
         * @description: 批量导入代码
         * @param {type}
         */
        uploadSectionFile (content) {
            this.treeLoading = true;
            let formdata = new FormData();
            formdata.append('codeFile', content.file);
            formdata.append('codeTypeId', this.codeTypeIdNew);
            axios({
                method: 'post',
                url: content.action,
                data: formdata,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': 'Bearer ' + JSON.parse(window.sessionStorage.getItem('access_token'))
                }
            }).then(async res => {
                if (res.code === 200) {
                    if (res.data.createWay === 1) {
                        // 添加代码类型后返回数据createWay为1，
                        // 则代码树中添加节点弹窗中代码不能编辑，若为2，则可以编辑。
                        // 但是在编辑节点中的所有弹窗都不能编辑代码字段。含义和业余代码可以编辑。
                        this.$refs.CodeTree.codeValuedisabled = true;
                    } else {
                        this.$refs.CodeTree.codeValuedisabled = false;
                    }
                    await this.getCodeTableData(this.columnData);
                    this.$message.success('导入成功!');
                    this.treeLoading = false;
                }
            }).catch((err) => {
                this.$message.error(err.msg);
                this.treeLoading = false;
            });
        },
        dragStart () {
            if (!this.fieldDraggable) {
                this.$message.warning('代码树已维护不可拖动');
            }
        },
        /**
         * @author: jingyh
         * @description: 通过代码树的数据判断是否可拖拽
         * @param {type}
         */
        changeFieldDraggable (val) {
            this.fieldDraggable = val;
        },
        /**
         * @author: liuc
         * @description: 多级代码保存或修改
         * @param {}:
         */
        async getCodeInfo (val, codeData, isAddChild) {
            if (val.type == '添加') {
                let param = {
                    aka: val.otherCode,
                    code: val.codeValue,
                    codeTypeId: this.codeTypeIdNew,
                    value: val.description
                };
                // isAddChild添加子级为true，同级为false
                if (isAddChild) {
                    if (val.currentNode.level !== 1) {
                        param.parent = val.currentNode.data.id;
                    }
                    if (val.currentNode.childNodes.length != 0) {
                        param.previous = val.currentNode.childNodes[val.currentNode.childNodes.length - 1].data.id;
                    }
                } else {
                    if (val.currentNode.level !== 2) {
                        param.parent = val.currentNode.parent.data.id;
                    }
                    if (val.currentNode.level !== 1) {
                        param.previous = val.currentNodeData.id;
                    }
                }
                let response = await this.$api.CodeManagement.getCode(param);
                if (response.code == 200) {
                    this.$message.success('新增成功！');
                    this.show(this.columnData);
                } else {
                    this.$message.error(response.msg);
                }
            } else {
                let param = {
                    id: val.currentNodeData.id,
                    value: val.description,
                    aka: val.otherCode
                };
                let response = await this.$api.CodeManagement.updateCode(param);
                if (response.code == 200) {
                    this.$message.success('修改成功！');
                } else {
                    this.$message.error(response.msg);
                }
            }
        },
        /**
         * @author: gzm
         * @description: 获取每一个代码类型对应的代码树
         * @param {type}
         */
        async getCodeTableData (data) {
            let res = await this.$api.CodeManagement.codetype(data.id);
            data.codesData = res.data;
            this.codesData = res.data;
            this.$refs.CodeTree.editDisabled = false;// 编辑打开后的代码树可操作
            if (res.data.createWay === 1) {
                // 添加代码类型后返回数据createWay为1，
                // 则代码树中添加节点弹窗中代码不能编辑，若为2，则可以编辑。
                // 但是在编辑节点中的所有弹窗都不能编辑代码。含义和业余代码可以编辑。
                this.$refs.CodeTree.codeValuedisabled = true;
            } else {
                this.$refs.CodeTree.codeValuedisabled = false;
            }
            this.$refs.CodeTree.treeData[0].codes = res.data.codes ? res.data.codes : [];
        },

        handleClose () {
            this.dialogVisible = false;
        },
        show (data) {
            this.columnData = data;
            this.codeTypeId = data.id;
            this.codeTypeIdNew = data.id;
            this.dialogVisible = true;
            if (data.codeType) {
                this.codeType = data.codeType;
                this.getCodeTableData(data);
            }
        }
    }
};
</script>
<style lang='scss' scoped>
.dialog-box {
    /deep/ .el-dialog {
        width: 1042px !important;
        height: 720px;
        .el-dialog__body {
            padding: 0;
            .dialog-content {
                padding: 0;
                overflow: hidden;
                .el-input__suffix {
                    display: flex;
                    align-items: center;
                }
                .right-box {
                    float: left;
                    width: 100%;
                    height: 580px;
                    border-bottom: 0;
                    // border-bottom: 1px solid #e1e1e1;
                    padding: 18px 40px 0 20px;
                    .el-table {
                        th.is-leaf {
                            padding: 0;
                            height: 35px;
                            background: #f5f5f5;
                        }
                        td {
                            padding: 0;
                            height: 70px;
                        }
                        .el-input__inner {
                            height: 26px;
                        }
                        .tree-box {
                            width: 270px;
                            height: 102px;
                            border: 1px solid rgba(224, 224, 224, 1);
                            margin: 10px 0;
                            padding-top: 10px;
                            overflow: auto;
                            .opreate-btns {
                                margin-left: 12px;
                            }
                            .el-tree-node__content {
                                border: 1px solid rgba(167, 0, 0, 0);
                            }
                            // .is-expanded > .el-tree-node__content:first-child {
                            //     border: 1px solid rgba(167, 0, 0, 1);
                            // }
                            .el-tree--highlight-current
                                .el-tree-node.is-current
                                > .el-tree-node__content {
                                border: 1px solid rgba(167, 0, 0, 0.2);
                                background-color: #f8ebeb;
                            }
                        }
                        .el-table__row > td:first-child,
                        .el-table__row > td:nth-child(2) {
                            vertical-align: baseline !important;
                        }
                        .el-select {
                            margin-top: 10px;
                        }
                    }
                    .addtree-but {
                        width: 142px;
                        height: 28px;
                        border-radius: 4px;
                        font-size: 18px;
                        margin-top: 10px;
                        padding-top: 5px;
                    }
                    .no-data {
                        position: relative;
                        height: 100%;
                        .desc {
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            transform: translate(-50%, -50%);
                            color: #ccc;
                            font-size: 16px;
                        }
                    }
                    .el-tag + .el-tag {
                        margin-left: 10px;
                        margin-top: 10px; // 修复单级代码换行后，无行距
                    }
                    .button-new-tag {
                        width: 90px;
                        margin: 10px 5px 0 10px; // 修复第二个单级代码带动内容下移
                        height: 32px;
                        line-height: 30px;
                        padding-top: 0;
                        padding-bottom: 0;
                    }
                    .input-new-tag {
                        width: 90px;
                        border-radius: 4px;
                        margin: 10px 5px 0 10px; // 修复第二个单级代码带动内容下移
                        vertical-align: bottom;
                    }
                    .single-level-code {
                        display: flex;
                        .code-wrap {
                            height: 100%;
                            flex: 1;
                        }
                        .batch-add-btn {
                            padding: 0 12px;
                            height: 32px;
                            line-height: 32px;
                            border-radius: 6px;
                            margin: 10px 0 0 10px;
                        }
                    }
                    .multi-level-code {
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        .title {
                            border-left: 4px solid #a70000;
                            padding-left: 8px;
                            margin-bottom: 20px;
                        }
                        .el-select + .el-select {
                            margin-left: 12px;
                        }
                        .select-wrap {
                            // height: 100px;
                            margin-bottom: 10px;
                            .code-header {
                                display: flex;
                                justify-content: space-between;
                                .el-button {
                                    // margin-bottom: 20px;
                                }
                            }
                            .input-box {
                                .el-input {
                                    width: 120px;
                                }
                            }
                        }
                        .tree-wrap {
                            flex: 1;
                            padding: 12px;
                            border: 1px solid #e1e1e1;
                            overflow-y: auto;
                        }
                    }
                }
                .svg-icon {
                    width: 24px;
                    height: 24px;
                    cursor: pointer;
                }
                .ok-icon {
                    color: #21be89 !important;
                }
            }
        }
        .el-dialog__footer {
            float: right;
            margin-top: 0px;
        }
    }
    .active {
        border-color: #a70000 !important;
        color: #a70000 !important;
    }
}
</style>



// WEBPACK FOOTER //
// ./src/components/Comencapsulation/cs-codeManagementdialog.vue